import React from 'react';

const OUTER =
  'M11.9015 19L3.08348 12.3422L1.41859 10.707C0.327724 9.63647 -0.159458 8.23755 0.0460055 6.76659C0.30866 4.8902 1.64735 3.06574 3.72106 1.75729C7.54861 -0.655211 12.7466 -0.573119 15.3054 1.93823L15.9853 2.60502L17.3304 1.75729C21.1579 -0.655211 26.356 -0.573119 28.9147 1.93823C30.0056 3.00878 30.4928 4.4077 30.2873 5.87866C30.0247 7.75505 28.686 9.58118 26.6123 10.888L24.0196 12.5181L11.9015 19Z';

const INNER =
  'M5.27157 10.7489L12.2192 15.9961L22.3081 10.5998L24.7631 9.05344C26.2246 8.132 27.163 6.88219 27.3388 5.62233C27.4214 5.02423 27.3621 4.15639 26.6038 3.41086C25.066 1.8997 21.7341 1.98179 19.1796 3.5918L15.5257 5.89373L12.9945 3.40919C11.4567 1.89802 8.12476 1.98012 5.57023 3.59013C4.10868 4.51157 3.17033 5.76138 2.99452 7.02124C2.91191 7.61934 2.97122 8.48718 3.72953 9.23271L5.27368 10.7489H5.27157Z';

const HeartIcon = ({ size = 16, filled = false, ...props }) => (
  <svg
    width={Math.round((size * 31) / 19)}
    height={size}
    viewBox='0 0 31 19'
    fill='currentColor'
    {...props}>
    <path d={filled ? OUTER : `${OUTER}${INNER}`} fillRule='evenodd' />
  </svg>
);

export default HeartIcon;
